import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function BlogCard({ post, featured }) {
  return (
    <motion.div
      whileHover={{ y: -6 }}
      className={`group glass rounded-2xl overflow-hidden glass-hover ${
        featured
          ? "hover:shadow-[0_0_30px_rgba(0,163,255,0.2)]"
          : "hover:shadow-[0_0_20px_rgba(0,163,255,0.12)]"
      } transition-all duration-300`}
    >
      <Link to={`/blog/${post.slug}`} className="block">
        <div className="relative overflow-hidden">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
          <span className="absolute top-3 left-3 glass text-[11px] font-semibold px-2.5 py-1 rounded-full text-cyber-blue">
            {post.category}
          </span>
        </div>
        <div className="p-5 flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <span className="text-gray-500 text-xs">{post.date}</span>
            {post.readingTime && (
              <>
                <span className="text-gray-600 text-xs">·</span>
                <span className="text-gray-500 text-xs">{post.readingTime}</span>
              </>
            )}
          </div>
          <h3
            className={`text-white font-bold leading-snug group-hover:text-cyber-blue transition-colors ${
              featured ? "text-2xl" : "text-base"
            }`}
          >
            {post.title}
          </h3>
          <p className="text-gray-400 text-sm leading-relaxed line-clamp-2">
            {post.excerpt}
          </p>
          <span className="inline-flex items-center gap-1 mt-2 text-tech-green text-sm font-semibold group-hover:translate-x-2 transition-transform">
            Read Article
            <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
